import { render, staticRenderFns } from "./EquityPenetrationRelationList.vue?vue&type=template&id=183205a1&scoped=true&"
import script from "./EquityPenetrationRelationList.vue?vue&type=script&lang=js&"
export * from "./EquityPenetrationRelationList.vue?vue&type=script&lang=js&"
import style0 from "./EquityPenetrationRelationList.vue?vue&type=style&index=0&id=183205a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183205a1",
  null
  
)

export default component.exports